<template>
    <v-card>
        <v-card-title class="font-italic grey--text darken-3 text-uppercase">{{ $t('contract') }}</v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" md="4">
                    <v-select
                        class="py-0 my-0"
                        v-model="orderData.contractFile"
                        :items="contracts"
                        hide-no-data
                        item-text="title"
                        item-value="id"
                        :label="$t('chooseContract')"
                        color="orange lighten-2"
                        item-color="orange lighten-2"
                        clearable
                        return-object
                    ></v-select>
                </v-col>
                <v-col cols="12" md="4" class="text-left text-md-center">
                    <v-btn
                        text
                        class="text--main-yellow"
                        :disabled="isDisabled"
                        @click="attach"
                    >
                        {{ $t('attach') }}
                    </v-btn>
                </v-col>
                <v-col cols="12" md="4" v-if="orderData.contractHistory && orderData.contractHistory.length" class="text-left text-md-center">
                    <contract-history :history="orderData.contractHistory" history-type="seller" :order-id="orderData.id"></contract-history>
                </v-col>
            </v-row>
        </v-card-text>
        <v-snackbar v-model="snackOpen" color="main--black" dark top content-class="pr-0">
            <v-row class="mx-0">
                <v-col cols="10" class="caption">
                    {{ snackText }}
                </v-col>
                <v-col cols="2" class="d-flex align-center justify-content-end text-right pr-0">
                    <v-btn small icon @click="snackOpen = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-snackbar>
    </v-card>
</template>

<script>
import AppSnackbar from "../../../../general/mixins/AppSnack"
import OrderExtendInfo from "../../../mixins/OrderExtendInfo"
import ContractHistory from "../../../components/contract-history"
import ContractsService from '../../../../app-front/services/api/ContractsService';

export default {
    name: "ExtendContractInfo",
    props: ['contracts'],
    mixins: [
        AppSnackbar,
        OrderExtendInfo
    ],
    components: {ContractHistory},
    data() {
        return {
            initialContractID: null,
        }
    },
    computed: {
        isDisabled() {
            if(!this.orderData.contractFile || !this.initialContractID) return false;

            return this.initialContractID === this.orderData.contractFile.id;
        }
    },
    methods: {
        attach() {
            const params = {
                contractId:  this.orderData.contractFile ? this.orderData.contractFile.id : null,
                orderId: this.orderData.id,
            };

            ContractsService.attachToOrder(params)
                .then(res => {
                    if(!res.data) return false;

                    this.responseHandle(res.data);
                })
                .catch(err => {
                    console.log(err);
                })
        },
        responseHandle(data) {
            this.snackText = data.msg;
            this.snackOpen = true;
            this.orderData.contractFile = data.contract;
            this.initialContractID = this.orderData.contractFile ? this.orderData.contractFile : null;
            this.valueChange('contractFile');
        }
    },
    watch: {
        order() {
            this.initialContractID = this.orderData.contractFile ? this.orderData.contractFile : null;
        }
    },
}
</script>
